import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  Toolbar,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { AiOutlineSearch } from "react-icons/ai";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { MdModeEdit } from "react-icons/md";
import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
import OrganizationRequest from "../../actions/organization";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FaUserSlash } from "react-icons/fa"; 

import produce from "immer";
import { MdAssignmentInd } from "react-icons/md";
import Popup from "../../components/customHelpers/Popup";
import Assignstaff from "./assignStaff";
import ChangePassword from "../../components/forms/updatePassword";

const headCells = [
  { id: "fullName", label: "Full Name", hideOnMobile: false },
  { id: "email", label: "Email", hideOnMobile: false },
  { id: "phoneNo", label: "Phone Number", hideOnMobile: true },
  { id: "username", label: "UserName", hideOnMobile: true },
  { id: "actions", label: "Actions", disableSorting: true },
];

const OrganizationDetalPage = () => {
  const { NotifyMessage, notify, setNotify } = Notify();
  const [Id, setId] = useState();
  const [staffId, setStaffId] = useState();
  const history = useHistory();
  const [openPopupAssign, setOpenPopupAssign] = useState(false);

  let location = useLocation();
  const [staff, setStaffs] = useState([]);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getAdminData(value);
    setId(value);
  }, [value]);
  const { viewAllOrganization, unlinkOrganization } = OrganizationRequest();

  const getAdminData = (id) => {
    setValues({
      ...values,
      loading: true,
    });
    viewAllOrganization(id ? id : Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.organization) {
        setValues({
          ...values,
          loading: false,
        });
        const staffList = data.organization.staffOrganizations.map(
          (org) => org.staff
        );

        setStaffs(staffList);
      }
    });
  };

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    unlinkOrganization(value,Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.message) {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setStaffs(
          produce(staff, (draft) => {
            const index = staff.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(staff, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["fullName", "email", "username"];

        if (target.value === "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            <ArrowBackIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push("/admin/organization");
              }}
            ></ArrowBackIcon>{" "}
            <span style={{ marginLeft: "6px" }}>Organization Users</span>
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search Staff"
              className="searchInput"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.fullName}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phoneNo}</TableCell>
                            <TableCell>{item.username}</TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="secondary"
                                title="Unlink"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: "Are you sure to Remove this Staff?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(item.id);
                                    },
                                  });
                                }}
                              >
                                <FaUserSlash fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Change Password"
                                onClick={() => {
                                  setOpenChangePassword(true);
                                  setStaffId(item.id);
                                }}
                              >
                                <MdModeEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Assign"
                                onClick={() => {
                                  setOpenPopupAssign(true);
                                  setStaffId(item.id);
                                }}
                              >
                                <MdAssignmentInd fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Assign Organization"
          openPopup={openPopupAssign}
          setOpenPopup={setOpenPopupAssign}
        >
          <Assignstaff
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopupAssign}
            id={staffId}
          />
        </Popup>
        <Popup
          title="Change Password"
          openPopup={openChangePassword}
          setOpenPopup={setOpenChangePassword}
        >
          <ChangePassword
            superadmin="true"
            id={staffId}
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenChangePassword}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default OrganizationDetalPage;
